import * as type from '../actions/types';
import {
  deleteItemsInArray,
  getItemInArray,
  insertItemInArrayAtIndex,
  updateItemInArray,
} from '../helpers/ArrayUtils';

const initialState = {
  data: [],
  localData: [],
  deleted: [],
  fetching: false,
  error: false,
  errorMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_OPTIONS_PENDING: {
      return {
        ...initialState,
        fetching: true,
      };
    }

    case type.FETCH_OPTIONS_SUCCESS: {
      return {
        ...state,
        data: action.payload || [],
        localData: action.payload || [],
        fetching: false,
        error: false,
        errorMessage: '',
      };
    }

    case type.FETCH_OPTIONS_FAILURE: {
      return {
        ...state,
        data: [],
        localData: [],
        deleted: [],
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    }

    case type.CREATE_OPTION: {
      const {
        objectId,
        optionTitle,
        optionDescription,
        minSelections,
        maxSelections,
        mandatory,
        restaurantId,
        posId,
        choiceIds,
      } = action.payload;

      const newOption = {
        objectId,
        optionTitle,
        optionDescription,
        mandatory,
        minSelections,
        maxSelections,
        restId: restaurantId,
        posId,
        importStatus: null,
        choiceIds,
        _created: true,
      };

      const newOptions = [...state.localData, newOption];

      return { ...state, localData: newOptions };
    }

    case type.UPDATE_OPTION: {
      const {
        objectId,
        title,
        description,
        minSelections,
        maxSelections,
        mandatory,
        restaurantId,
        posId,
        choiceIds,
        importStatus,
      } = action.payload;

      const newOptions = updateItemInArray(state.localData, 'objectId', objectId, (option) => ({
        ...option,
        optionDescription: description,
        optionTitle: title,
        restId: restaurantId,
        minSelections,
        maxSelections,
        mandatory,
        posId,
        choiceIds,
        importStatus,
        _altered: true,
      }));

      // Update state, but also remove the temporary choices
      return { ...state, localData: newOptions };
    }

    case type.DELETE_OPTION: {
      const { optionId } = action.payload;

      const deleted = getItemInArray(state.localData, 'objectId', optionId);

      const newDeleted = { ...deleted, _deleted: true };

      const newOptions = deleteItemsInArray(state.localData, 'objectId', optionId);

      const newDeletedItems = insertItemInArrayAtIndex(state.deleted, 0, newDeleted);

      return {
        ...state,
        localData: newOptions,
        deleted: newDeletedItems,
      };
    }

    case type.CLEAR_OPTIONS: {
      return initialState;
    }

    // Remove the choice from all options that contain it
    case type.DELETE_CHOICE: {
      const { choiceId } = action.payload;

      const updatedOptions = state.localData.map((option) => {
        if (!option?.choiceIds?.includes(choiceId)) {
          return option;
        }

        const newChoices = option?.choiceIds?.filter(
          (optionChoiceId) => optionChoiceId !== choiceId,
        );
        const updatedOption = {
          ...option,
          choiceIds: newChoices,
          _altered: true,
        };
        return updatedOption;
      });

      return {
        ...state,
        localData: updatedOptions,
      };
    }

    case type.BULK_REVIEW_OPTIONS: {
      const { optionIds } = action.payload;

      const newOptions = state.localData.map((option) => {
        if (optionIds?.includes(option.objectId)) {
          return { ...option, importStatus: 'reviewed', _altered: true };
        }
        return option;
      });

      return {
        ...state,
        localData: newOptions,
      };
    }

    /*
     * BACKEND SAVES
     */

    case type.BACKEND_SAVE_OPTION_SUCCESS: {
      const { savedItem, itemObjectId } = action.payload;

      const newOptions = state.localData.map((item) => {
        if (item.objectId === itemObjectId) {
          return savedItem;
        }

        return item;
      });

      return {
        ...state,
        data: newOptions,
        localData: newOptions,
      };
    }

    case type.BACKEND_SAVE_OPTIONS_SUCCESS: {
      const newOptions = state.localData.map(({ _altered, _created, _objectId, ...rest }) => rest);

      return {
        ...state,
        data: newOptions,
        localData: newOptions,
        deleted: [],
      };
    }

    default: {
      return state;
    }
  }
};
